// @flow
export const SHOW_TICKET_MODAL = 'tickets/SHOW_TICKET_MODAL';
export const HIDE_TICKET_MODAL = 'tickets/HIDE_TICKET_MODAL';
export const UPDATE_TICKET_DATA = 'tickets/UPDATE_TICKET_DATA';
export const CREATE_TICKET = 'tickets/CREATE_TICKET';
export const PERSIST_TICKET = 'tickets/PERSIST_TICKET';
export const SET_TICKET_TYPE = 'tickets/SET_TICKET_TYPE';
export const SET_TICKET_LIST = 'tickets/SET_TICKET_LIST';
export const PERSIST_TICKET_FORM_DATA = 'tickets/PERSIST_TICKET_FORM_DATA';
export const UPDATE_TICKET_FORM_DATA = 'tickets/UPDATE_TICKET_FORM_DATA';
export const UPDATE_TICKET_IN_LIST = 'tickets/UPDATE_TICKET_IN_LIST';
export const REMOVE_TICKET_FROM_LIST = 'tickets/REMOVE_TICKET_FROM_LIST';
export const HIDE_TICKET_FORM = 'tickets/HIDE_TICKET_FORM';
export const SHOW_TICKET_FORM = 'tickets/SHOW_TICKET_FORM';

export const SET_STATUS_FILTERS = 'tickets/SET_STATUS_FILTERS';

export function showTicketModal( data ) {
    return {
        type: SHOW_TICKET_MODAL,
        payload: data
    };
}

export function hideTicketModal() {
    return {
        type: HIDE_TICKET_MODAL,
    };
}

export function updateTicketData( data ) {
    return {
        type: UPDATE_TICKET_DATA,
        payload: data
    };
}

export function persistTicket( data ) {
    return {
        type: PERSIST_TICKET,
        payload: data
    };
}

export function createTicket() {
    return {
        type: CREATE_TICKET,
    };
}


export function setTicketType( data ) {
    return {
        type: SET_TICKET_TYPE,
        payload: data
    };
}

export function setTicketList( data ) {
    return {
        type: SET_TICKET_LIST,
        payload: data
    };
}

export function showTicketForm( data ) {
    return {
        type: SHOW_TICKET_FORM,
        payload: data,
    }
}

export function hideTicketForm() {
    return {
        type: HIDE_TICKET_FORM
    }
}

export function updateTicketFormData( data ) {
    return {
        type: UPDATE_TICKET_FORM_DATA,
        payload: data,
    }
}

export function updateTicketInList( data ) {
    return {
        type: UPDATE_TICKET_IN_LIST,
        payload: data,
    }
}

export function removeTicketFromList(id){
    return{
        type: REMOVE_TICKET_FROM_LIST,
        payload: id
    }
}

export function persistTicketFormData( data ) {
    return {
        type: PERSIST_TICKET_FORM_DATA,
        payload: data,
    }
}

export function setStatusFilters (data) {
    return {
        type: SET_STATUS_FILTERS,
        payload: data
    }
}


